// src/config/api-config.js

export const serverUrl = 'https://presents.resn.global/xmas-2023'; // temp server